import { AllocationBase } from '../../accounting/abstract/allocation-base.model';

export class SalesInvoiceAllocation extends AllocationBase {

    static override CLASS_NAME: string = 'SalesInvoiceAllocation';

}
